// Lower number = renders higher in the stack.
// emailMarketingCountdown needs to be the last one.
const BANNER_STACK_PRIORITY = {
  storeDisabled: 1,
  storeHolidays: 2,
  storeSpecialHours: 3,
  pausedChannels: 4,
  unPublish: 5,
  surveyDisabled: 6,
  cashbackDisabled: 7,
  publishProgress: 8,
  emailMarketingCountdown: 9
};

export default BANNER_STACK_PRIORITY;
